import * as React from 'react';

import TabsSection from 'components/tabs/tabs-section/TabsSection';

import type { TabsSectionItem } from 'types';
import { availableBrandTabsSelector } from '../../selectors/brand-filters/brandFilters';
import { connect } from 'react-redux';

type OwnProps = {
  onChange: (a?: string | null) => void,
  activeBrandFilter: string
};

type StateProps = {
  items: Array<TabsSectionItem>
};

type Props = OwnProps & StateProps;

const BrandTabs = ({
  items,
  activeBrandFilter,
  onChange
}: Props) => (
  <TabsSection
    items={items}
    activeTab={activeBrandFilter}
    onClick={(tab) => onChange(tab)}
  />
);

const mapStateToProps = (state, props): StateProps => ({
  items: availableBrandTabsSelector(state, props)
});

export default connect(mapStateToProps)(BrandTabs);
